import { axiosSwagger } from "@/axios";

export const state = {
    trashFile: {
        loading: false,
        data: [],
        total: 0,
    },
}


export const getters = {
}


export const mutations = {
    // TRASH FILE
    trashFileLoading: (state, loading) => {
        state.trashFile.loading = loading;
    },
    setTrashFileData: (state, data) => {
        state.trashFile.data = data;
    },
    setTrashFileTotal: (state, total) => {
        state.trashFile.total = total;
    },
    removeTrashFile: (state, id) => {
        state.trashFile.data = state.trashFile.data.filter(
            (el) => el.id !== id
        );
    },
    removeMultipleTrashFile: (state, dataArr) => {
        state.trashFile.data = state.trashFile.data.filter(
          (el) => !dataArr?.includes(el.id)
        );
    }
}


export const actions = {
    // READ TRASH FILE
    async readTrashFile({ commit }) {
        commit("trashFileLoading", true);

        const userData = localStorage.getItem("USER") !== null && localStorage.getItem("USER") !== '' ? JSON.parse(localStorage.getItem("USER")) : null;

        return await axiosSwagger
            .get(`/api/FileManager/Trash/${userData?.deliveryUnit?.id}`)
            .then((response) => {
                commit("setTrashFileData", response.data);
                commit("setTrashFileTotal", response.data.length);
                commit("trashFileLoading", false);

                return response;
            })
        .catch(() => {
            commit("trashFileLoading", false);
        });
    },
    // RESTORE FILE
    async restoreFile({ commit }, id) {
        return await axiosSwagger
            .put(`/api/FileManager/Restore/${id}`)
            .then((response) => {
                commit("removeTrashFile", id);
                return response;
            });
    },
    // DELETE FILE FOREVER
    async deleteFileForever({ commit }, id) {
        return await axiosSwagger
            .delete(`/api/FileManager/${id}`)
            .then((response) => {
                commit("removeTrashFile", id);
                return response;
            });
    },
    async multipleDeleteFileForever({ commit }, data) {
        return await axiosSwagger
            .post(`/api/FileManager/Remove`, data)
            .then((response) => {
                commit("removeMultipleTrashFile", data.map(e => e.id));

                return response;
            });
    },
}